import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { DialogExpander } from 'ui/common/dialog-expander/dialog-expander';
import { NoValueDash } from 'ui/common';
import { actionCreators } from './actions';
import { selectImportCaseDetails } from 'app/area/import/selectors';
import { ElementLoader } from 'ui';
import { ClearImportDetails } from 'app/area/import/action-types';
import styles from './import-view.scss';

export interface ImportDetailViewProps {
  id: number;
  showDetails: boolean;
  translation: any;
  handleClose: () => void;
}

export const ImportDetailView: React.FC<ImportDetailViewProps> = ({
  id,
  showDetails,
  translation,
  handleClose
}: ImportDetailViewProps) => {
  const dispatch = useDispatch();
  const importCaseDetails = useSelector(selectImportCaseDetails);

  useEffect(() => {
    if (showDetails) {
      dispatch(actionCreators.loadImportDetails(id));
    }
    return () => {
      dispatch(new ClearImportDetails());
    };
  }, [showDetails, id]);

  return showDetails ? (
    <DialogExpander
      onClose={handleClose}
      hasFooter={false}
      className="tile-details-view">
        {importCaseDetails?.fetching ? <ElementLoader /> :
        importCaseDetails?.importCase?.importTranses && <>
        {importCaseDetails?.importCase?.importTranses
          .filter(item => item.importErrors.length > 0)
          .map((item, index) => <div key={index} className={styles.importDetailsTile}>
          <div className={styles.errorMessage}>
            <label>{translation.import_details_error}</label>
            {item.importErrors.length > 0 ? [...item.importErrors].map((error, i) => 
              <p key={i}>{error}</p>)
              : <NoValueDash/>
            }
          </div>

          <ul className={styles.detailsTileFooter}>
            <li>
              <span>{translation.import_details_case_number}: </span>
              <span>{item.importTransId}</span>
            </li>
            <li>
              <span>{translation.import_details_db}: </span>
              <span>{item.importDatabaseId}</span>
            </li>
          </ul>
        </div>)}
      </>}
    </DialogExpander>
  ) : null;
};
